import { render, staticRenderFns } from "./UsSuperMillions.vue?vue&type=template&id=4713f638&scoped=true"
import script from "./UsSuperMillions.vue?vue&type=script&lang=js"
export * from "./UsSuperMillions.vue?vue&type=script&lang=js"
import style0 from "./UsSuperMillions.vue?vue&type=style&index=0&id=4713f638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4713f638",
  null
  
)

export default component.exports